import { RouteObject } from 'react-router'

import { PLATFORM } from '@/constants/platform'
import { STREAMING_MENU_ICONS } from '@/router/icons'
import { PageUnderConstruction } from '@/views/PageUnderConstruction'

export const contentRoutes: RouteObject[] = [
  {
    path: 'content',
    label: 'Content',
    icon: STREAMING_MENU_ICONS.CONTENT,
    platforms: [PLATFORM.DGE],
    children: [
      {
        index: true,
        element: <PageUnderConstruction />,
        platforms: [PLATFORM.DGE]
      }
    ]
  }
]
